var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 0)"},React.createElement("g",{"className":"fillable","fill":"#F7F7F7"},React.createElement("path",{"d":"M31.331,8.248c-.368-1.386-1.452-2.477-2.829-2.848-2.496-.673-12.502-.673-12.502-.673,0,0-10.007,0-12.502,.673-1.377,.37-2.461,1.462-2.829,2.848-.669,2.512-.669,7.752-.669,7.752,0,0,0,5.241,.669,7.752,.368,1.386,1.452,2.477,2.829,2.847,2.496,.673,12.502,.673,12.502,.673,0,0,10.007,0,12.502-.673,1.377-.37,2.461-1.462,2.829-2.847,.669-2.512,.669-7.752,.669-7.752,0,0,0-5.24-.669-7.752ZM12.727,20.758V11.242l8.364,4.758-8.364,4.758Z"}))));
}

Youtube.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Youtube;

Youtube.default = Youtube;
